import { NctsCountry } from 'config'

export const CANCELLATION_REASON_MAX_LENGTH = 512

const MEANINGFUL_CHARACTER = /[\p{L}\p{N}]/u

export const isValidCancellationReason = (reason: string) => MEANINGFUL_CHARACTER.test(reason)

export const requiresUserWrittenCancellationReason = (country: NctsCountry | null) => country === 'PL'
